// extracted by mini-css-extract-plugin
export default {"mainContainer":"private_mainContainer__MX9eZ","mobileBarButton":"private_mobileBarButton__yqYrd","main":"private_main__SeBv4"};